import React from 'react'
import styled from 'styled-components'
import PGAMasterProLogo from '../assets/PGAMasterProLogo.png'
import PGAMemberLogo from '../assets/PGAMemberLogo.png'

export const Img = styled.img`
  height: 74px;
  width: 74px;
`

export const PGAProLogo = PGAMemberLogo
export const MasterProLogo = PGAMasterProLogo
export const CertifiedProLogo = PGAMemberLogo
export const SpecializedLogo = PGAMemberLogo

export default ({ me }) => {
  const { certifiedProfessional, masterProfessional, specializedProfessional, type } = me
  const hasMemberType = type === 'MB'

  if (masterProfessional) return <Img src={MasterProLogo} alt='Master Professional' />
  if (certifiedProfessional) return <Img src={CertifiedProLogo} alt='Certified Professional' />
  if (specializedProfessional) return <Img src={SpecializedLogo} alt='Specialized Professional' />
  if (hasMemberType) return <Img src={PGAProLogo} alt='PGA Professional' />
  return null
}
